// extracted by extract-css-chunks-webpack-plugin
module.exports = {"protocol":"protocol_2_-St","list":"list_2-nVz"};